
export function requireToUrl(path) {
  return require.toUrl(path);
}
